export const IconPerformingPublicly = ({size = 20, color = "#000"}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox={`0 0 ${size + 15} ${size + 15}`} fill="none">
    <path
      d="M15.125 2.75C10.3437 2.75 5.70312 2.1875 1.625 1.0625C1.34375 2.89062 1.0625 4.85938 1.0625 6.82813C1.0625 19.2031 7.39062 29.1875 15.125 29.1875C22.8594 29.1875 29.1875 19.2031 29.1875 6.82813C29.1875 4.85938 29.0469 2.89062 28.625 1.0625C24.5469 2.1875 19.9063 2.75 15.125 2.75Z"
      stroke={color} strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)